/**
 * HexBadge — NCPD security clearance style badge.
 */

import { type ReactNode } from "react";

interface HexBadgeProps {
  children?: ReactNode;
  label?: string;
  variant?: "default" | "accent" | "success" | "warning" | "danger" | "primary" | "secondary" | "warn" | "muted";
  size?: "sm" | "md";
}

export function HexBadge({
  children,
  label,
  variant = "default",
  size = "sm",
}: HexBadgeProps) {
  const sizeClasses = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-3 py-1 text-sm",
  };

  const variantClasses: Record<string, string> = {
    default: "bg-[var(--bw-surface-2)] text-[var(--bw-muted)] border-[var(--bw-border)]",
    accent: "bg-[var(--bw-accent)]/10 text-[var(--bw-accent)] border-[var(--bw-accent)]",
    primary: "bg-[var(--bw-accent)]/10 text-[var(--bw-accent)] border-[var(--bw-accent)]",
    secondary: "bg-[var(--bw-muted)]/10 text-[var(--bw-muted)] border-[var(--bw-muted)]",
    muted: "bg-[var(--bw-surface-2)] text-[var(--bw-muted)] border-[var(--bw-border)]",
    success: "bg-[var(--bw-success)]/10 text-[var(--bw-success)] border-[var(--bw-success)]",
    warning: "bg-[var(--bw-warn)]/10 text-[var(--bw-warn)] border-[var(--bw-warn)]",
    warn: "bg-[var(--bw-warn)]/10 text-[var(--bw-warn)] border-[var(--bw-warn)]",
    danger: "bg-[var(--bw-danger)]/10 text-[var(--bw-danger)] border-[var(--bw-danger)]",
  };

  return (
    <span
      className={`
        ${sizeClasses[size]}
        ${variantClasses[variant]}
        inline-flex items-center
        font-mono uppercase tracking-wider
        border
        clip-path-[polygon(8px_0,100%_0,100%_calc(100%-8px),calc(100%-8px)_100%,0_100%,0_8px)]
      `}
      style={{
        clipPath: "polygon(6px 0, 100% 0, 100% calc(100% - 6px), calc(100% - 6px) 100%, 0 100%, 0 6px)",
      }}
    >
      {children ?? label}
    </span>
  );
}
